module.exports = __webpack_public_path__ + "img/app9.6af96f36.png";